'use client'

import posthog from 'posthog-js'
import { hashString } from '../internal/hash-utils'
import {
  captureDebug as captureDebugServer,
  identifyUserDebug as identifyUserDebugServer,
} from '../internal/server/debug'
import type { EventName, EventProperties } from '../types'

export function captureDebug<T extends EventName>(
  eventName: T,
  properties: EventProperties<T> = {} as EventProperties<T>,
): void {
  captureDebugServer(eventName, properties).catch(() => {})
}

export function capture<T extends EventName>(
  eventName: T,
  properties: EventProperties<T> = {} as EventProperties<T>,
): void {
  if (typeof window === 'undefined') return
  posthog.capture(eventName, properties)
}

export async function identifyUserDebug(
  userId: string,
  properties: Record<string, any> = {},
): Promise<void> {
  // TODO: implement user consent mechanism for email hashing
  const hasConsent = false

  const enrichedProperties = { ...properties }
  if ('user_email' in enrichedProperties && !hasConsent) {
    enrichedProperties.user_email = await hashString(enrichedProperties.user_email as string)
  }
  if ('user_given_name' in enrichedProperties && !hasConsent) {
    enrichedProperties.user_given_name = await hashString(
      enrichedProperties.user_given_name as string,
    )
  }
  if ('user_family_name' in enrichedProperties && !hasConsent) {
    enrichedProperties.user_family_name = await hashString(
      enrichedProperties.user_family_name as string,
    )
  }

  identifyUserDebugServer(userId, enrichedProperties).catch(() => {})
}

export async function identifyUser(
  userId: string,
  properties: Record<string, any> = {},
): Promise<void> {
  if (typeof window === 'undefined') return

  // TODO: implement user consent mechanism for email hashing
  const hasConsent = false

  const enrichedProperties = { ...properties }
  if ('user_email' in enrichedProperties && !hasConsent) {
    enrichedProperties.user_email = await hashString(enrichedProperties.user_email as string)
  }
  if ('user_given_name' in enrichedProperties && !hasConsent) {
    enrichedProperties.user_given_name = await hashString(
      enrichedProperties.user_given_name as string,
    )
  }
  if ('user_family_name' in enrichedProperties && !hasConsent) {
    enrichedProperties.user_family_name = await hashString(
      enrichedProperties.user_family_name as string,
    )
  }

  posthog.identify(userId, enrichedProperties)
}
